var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mb-2",on:{"click":function($event){return _vm.onClick()}}},[(_vm.icon !== '')?_c('img',{attrs:{"src":_vm.icon,"alt":""}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.caption))])])}
var staticRenderFns = []

export { render, staticRenderFns }